export default __webpack_public_path__ + "static/SSSpyView_screenshot-3@mob2x-28d2e7d767fc8d9f12a9686aba0adb7e.jpg";